import { BaseUITools } from "@/uiControls/base/baseUITools";
import { createNumericSliderUI, NumericSliderUI } from "@/uiControls/base/ui/numericSliderUI";
import { createSwitchUI, SwitchUI } from "@/uiControls/base/ui/switchUI";
import { CheckButtonGroupUI } from "@/uiControls/base/ui/checkButtonGroupUI";
import { cameraUtils } from "@/utils/cameraUtils";
import { globalConfig, globalManager } from "@/utils/globalConfig";
import { sceneUtils } from "@/utils/sceneUtils";
import { ColorSelectorAntUI } from "@/uiControls/base/ui/colorSelectorUI";
import { ColorSelectorPickrUI } from "@/uiControls/base/ui/colorSelectorUI copy 2";
import { NumericInputUI } from "@/uiControls/base/ui/numericInputUI";
import { Vector3ControlUI } from "../base/components/vector3ControlUI";
import { SelectUI } from "../base/ui/selectUI";
import { getI18nText } from "@/utils/commonFunc";
import { SkyboxSelectUI } from "../base/ui/skyboxSelectUI";
// 模型辅助工具，扩展多视窗，与Scene无绑定关系，单独使用
export class LightPanelTools extends BaseUITools {
    private ortControl: CheckButtonGroupUI | null = null; // 控制器
    private dragSpeedControl: NumericSliderUI | null = null; // 拖拽速度
    private scaleSpeedControl: NumericSliderUI | null = null; // 缩放速度
    private dempingControl: NumericSliderUI | null = null; // 阻尼
    private isActive: boolean = false; // 是否激活
    private animateControlDom: SwitchUI | null = null; // 动画

    private ambientLightControl: ColorSelectorAntUI | null = null; // 环境光控制器
    private ambientLightIntensityControl: NumericSliderUI | null = null; // 环境光强度控制器
    // private ambientLightIntensityControl: NumericInputUI | null = null; // 环境光强度控制器

    private directLightEnableControl: SwitchUI | null = null; // 平行光源开关
    private directLightControl: ColorSelectorPickrUI | null = null; // 平行光源控制器
    // private directLightIntensityControl: NumericSliderUI | null = null; // 平行光源强度控制器
    private directLightIntensityControl: NumericInputUI | null = null; // 平行光源强度控制器
    private directPosControlDom: Vector3ControlUI | null = null; // 平行光源位置控制器
    private skyboxSelectControl: SkyboxSelectUI | null = null; // 天空盒选择控制器

    constructor(id: string) {
        super(id, false);
        this.init();
    }

    init() {
        const panelContainerElement = this.ui.createElement({
            tag: 'div',
            className: 'panel-setting-container',
        });
        const titleElement = this.ui.createElement({
            tag: 'div',
            className: 'panel-setting-title',
        });
        const titleLeftElement = this.ui.createElement({
            tag: 'div',
            textContent: '光源设置',
            className: 'panel-setting-title-left',
            i18nKey: 'title.lightSettings'
        });
        const titleRightElement = this.ui.createElement({
            tag: 'div',
            className: 'panel-setting-title-right',
        });
        const resetButtonElement = this.ui.createButton({
            textContent: '重置',
            className: ['btn-item', 'btn-text-item', 'inherit-font-size'],
            i18nKey: 'buttons.reset'
        })
        resetButtonElement.addEventListener('click', () => {
            this.onReset();
            this.setActive(false);
        });
        titleRightElement.appendChild(resetButtonElement);

        const closeButtonElement = this.ui.createButton({
            iconName: 'cuowu1',
            isIconOnly: true,
            className: ['btn-item', 'btn-icon-item', 'inherit-font-size'],
            // i18nKey: 'buttons.close'
        })
        closeButtonElement.addEventListener('click', () => {
            this.onClose();
        });
        titleRightElement.appendChild(closeButtonElement);

        titleElement.appendChild(titleLeftElement);
        titleElement.appendChild(titleRightElement);
        panelContainerElement.appendChild(titleElement);

        const lightControlElement = this.initLightControl();
        panelContainerElement.appendChild(lightControlElement);

        this.appendChild('panelContainer', panelContainerElement);
    }

    initLightControl() {
        const viewElement = this.ui.createElement({
            tag: 'div',
            className: 'panel-setting-view',
        });
        const viewTitleElement = this.ui.createElement({
            tag: 'div',
            textContent: '光源设置',
            className: 'panel-setting-view-title',
            i18nKey: 'label.lightSettings',
        });
        viewElement.appendChild(viewTitleElement);

        const ambientLightContainer = this.ui.createElement({
            tag: 'div',
            className: 'panel-setting-group',
        });
        // 环境光
        const ambientLightTitleElement = this.ui.createElement({
            tag: 'div',
            textContent: '环境光',
            className: 'panel-setting-view-sub-title',
            i18nKey: 'lightSettings.ambientLight',
        });
        ambientLightContainer.appendChild(ambientLightTitleElement);
        // 颜色选择器
        const ambientLightControl = new ColorSelectorAntUI({
            label: getI18nText('lightSettings.color'),
            showLabel: true,
            showValue: true,
            containerClass: 'panel-setting-item',
            labelClass: 'panel-setting-item-label',
            color: globalConfig.lightSettings.ambientLight.color,
            i18nKey: 'lightSettings.color',
        });
        ambientLightControl.getContainer().classList.add('panel-setting-group-item');
        this.ambientLightControl = ambientLightControl;
        ambientLightControl.onChange((value) => {
            sceneUtils.setAmbientLightColor(value);
        });
        ambientLightContainer.appendChild(ambientLightControl.getContainer());

        // 强度
        const ambientLightIntensityControl = createNumericSliderUI({
            containerClass: 'panel-setting-item',
            label: '强度',
            showValue: false,
            value: globalConfig.lightSettings.ambientLight.intensity,
            min: 0,
            max: 100,
            step: 1,
            labelClass: 'panel-setting-item-label',
            sliderContainerClass: 'panel-setting-item-content',
            i18nKey: 'lightSettings.intensity',
        });
        // const ambientLightIntensityControl = new NumericInputUI({
        //     containerClass: ['panel-setting-item','panel-setting-group-item'],
        //     label: '强度',
        //     showValue: false,
        //     value: globalConfig.lightSettings.ambientLight.intensity,
        //     min: 0,
        //     max: 100,
        //     step: 1,
        //     labelClass: 'panel-setting-item-label',
        //     i18nKey: 'lightSettings.intensity',
        // });
        this.ambientLightIntensityControl = ambientLightIntensityControl;
        ambientLightIntensityControl.onChange((value) => {
            console.log('ambientLightIntensityControl onChange', value);
            sceneUtils.setAmbientLightIntensity(value);
        });
        ambientLightContainer.appendChild(ambientLightIntensityControl.getContainer());
        viewElement.appendChild(ambientLightContainer);

        // 平行光源
        const directLightContainer = this.ui.createElement({
            tag: 'div',
            className: 'panel-setting-group',
        });
        const directLightTitleElement = this.ui.createElement({
            tag: 'div',
            textContent: '平行光源',
            className: 'panel-setting-view-sub-title',
            i18nKey: 'lightSettings.directionalLight',
        });
        directLightContainer.appendChild(directLightTitleElement);
        // 平行光源开启开关
        const directLightEnableControl = createSwitchUI({
            containerClass: 'panel-setting-item',
            label: '开启',
            checked: globalConfig.lightSettings.mainDirectionalLight.enabled,
            labelClass: 'panel-setting-item-label',
            switchContainerClass: 'panel-setting-item-content',
            i18nKey: 'lightSettings.enable',
        });
        this.directLightEnableControl = directLightEnableControl;
        this.directLightEnableControl.onChange((value) => {
            console.log('directLightEnableControl onChange', value);
            this.directLightControl.setDisabled(!value as boolean);
            this.directLightIntensityControl.setDisabled(!value as boolean);
            this.directPosControlDom.setDisabled(!value as boolean);
            sceneUtils.setDirectionalLightEnabled(value as boolean);
        });
        directLightContainer.appendChild(directLightEnableControl.getContainer());
        // 颜色选择器
        const directLightControl = new ColorSelectorPickrUI({
            label: getI18nText('lightSettings.color'),
            showLabel: true,
            showValue: true,
            containerClass: 'panel-setting-item',
            labelClass: 'panel-setting-item-label',
            color: globalConfig.lightSettings.mainDirectionalLight.color,
            i18nKey: 'lightSettings.color',
        });
        directLightControl.getContainer().classList.add('panel-setting-group-item');
        this.directLightControl = directLightControl;
        directLightControl.onChange((value) => {
            sceneUtils.setDirectionalLightColor(value);
        });
        directLightContainer.appendChild(directLightControl.getContainer());

        // 强度
        // const directLightIntensityControl = createNumericSliderUI({
        //     containerClass: 'panel-setting-item',
        //     label: '强度',
        //     showValue: false,
        //     value: globalConfig.lightSettings.directLight.intensity,
        //     min: 0,
        //     max: 100,
        //     step: 1,
        //     labelClass: 'panel-setting-item-label',
        //     sliderContainerClass: 'panel-setting-item-content',
        //     i18nKey: 'lightSettings.intensity',
        // });
        const directLightIntensityControl = new NumericInputUI({
            containerClass: ['panel-setting-item', 'panel-setting-group-item'],
            label: '强度',
            showValue: false,
            value: globalConfig.lightSettings.mainDirectionalLight.intensity,
            min: 0,
            max: 100,
            step: 1,
            labelClass: 'panel-setting-item-label',
            i18nKey: 'lightSettings.intensity',
        });
        this.directLightIntensityControl = directLightIntensityControl;
        directLightIntensityControl.onChange((value) => {
            console.log('directLightIntensityControl onChange', value);
            sceneUtils.setDirectionalLightIntensity(value);
        });
        directLightContainer.appendChild(directLightIntensityControl.getContainer());

        // 位置
        const directPosControlElement = new Vector3ControlUI({
            label: '位置',
            containerClass: 'panel-setting-view',
            valueOptions: new Map([
                ['x', { id: 'directPosX', label: 'X', value: globalConfig.lightSettings.mainDirectionalLight.position.x, step: 0.1, precision: -1, disabled: false, readonly: false, showValue: false, valueFormat: (value: number) => value.toFixed(4) }],
                ['y', { id: 'directPosY', label: 'Y', value: globalConfig.lightSettings.mainDirectionalLight.position.y, step: 0.1, precision: -1, disabled: false, readonly: false, showValue: false, valueFormat: (value: number) => value.toFixed(4) }],
                ['z', { id: 'directPosZ', label: 'Z', value: globalConfig.lightSettings.mainDirectionalLight.position.z, step: 0.1, precision: -1, disabled: false, readonly: false, showValue: false, valueFormat: (value: number) => value.toFixed(4) }],
            ]),
            isLabelInline: true,
            i18nKey: 'lightSettings.position'
        });
        this.directPosControlDom = directPosControlElement;
        directPosControlElement.onChange((value) => {
            sceneUtils.setDirectionalLightPosition(value);
        });
        directLightContainer.appendChild(directPosControlElement.getContainer());
        viewElement.appendChild(directLightContainer);

        // 天空盒
        const skyboxContainer = this.ui.createElement({
            tag: 'div',
            className: 'panel-setting-group',
        });
        const skyboxSettingsTitleElement = this.ui.createElement({
            tag: 'div',
            textContent: '天空盒设置',
            className: 'panel-setting-view-sub-title',
            i18nKey: 'lightSettings.skyboxSettings',
        });
        skyboxContainer.appendChild(skyboxSettingsTitleElement);
        const skyboxSelectControl = new SkyboxSelectUI({
            label: '天空盒',
            showLabel: true,
            showValue: true,
            containerClass: 'panel-setting-item',
            labelClass: 'panel-setting-item-label',
            value: globalConfig.lightSettings.skyboxSettings.url,
            i18nKey: 'lightSettings.skyboxSettings',
            options: [
                {
                    value: '1',
                    text: getI18nText('lightSettings.skybox.none'),
                    i18nKey: 'lightSettings.skybox.none'
                },
                {
                    value: '2',
                    text: getI18nText('lightSettings.skybox.skybox'),
                    i18nKey: 'lightSettings.skybox.skybox'
                }
            ]
        });
        skyboxSelectControl.getContainer().classList.add('panel-setting-group-item');
        this.skyboxSelectControl = skyboxSelectControl;
        skyboxSelectControl.onChange((value) => {
            console.log('skyboxSelectControl onChange', value);
            // sceneUtils.setSkyboxSettings(value);
        });
        skyboxContainer.appendChild(skyboxSelectControl.getContainer());
        viewElement.appendChild(skyboxContainer);

        return viewElement;
    }

    setupEventHandlers() {
        window.addEventListener('event.panelTabChange', (event: Event) => {
            console.log('panelTabChange', event);
            const detail = (event as CustomEvent).detail;
            this.setActive(detail === 'scene');
            this.update();
        });
    }
    onReset() {
        console.log('重置');
    }
    onClose() {
        console.log('关闭');
        globalManager.closeRightToolsBar();
    }
    update() {
        if (this.isActive) {

        }
    }
    setActive(active: boolean) {
        this.isActive = active;
    }
}
